import { Flag } from 'lucide-react';
import { Race } from '../types';
import { daysUntil } from '../services/races';

interface RaceStripProps {
  races: Race[];
}

const countdown = (days: number): string => {
  if (days === 0) return 'Today!';
  if (days === 1) return 'Tomorrow';
  if (days < 14) return `${days} days`;
  return `${Math.round(days / 7)} weeks`;
};

const priorityClasses: Record<Race['priority'], string> = {
  A: 'bg-indigo-600 text-white',
  B: 'bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-200',
  C: 'bg-zinc-100 text-zinc-500 dark:bg-zinc-800 dark:text-zinc-400',
};

export function RaceStrip({ races }: RaceStripProps) {
  if (races.length === 0) return null;

  return (
    <div className="flex gap-3 overflow-x-auto pb-1">
      {races.map((race, i) => {
        const days = daysUntil(race.race_date);
        return (
          <div
            key={race.id}
            className={`flex min-w-fit items-center gap-3 rounded-xl px-4 py-2.5 ring-1 ${
              i === 0
                ? 'bg-indigo-600/5 ring-indigo-600/20 dark:bg-indigo-400/5 dark:ring-indigo-400/20'
                : 'bg-white ring-zinc-950/5 dark:bg-zinc-900 dark:ring-white/10'
            }`}
          >
            <Flag className={`h-4 w-4 shrink-0 ${i === 0 ? 'text-indigo-600 dark:text-indigo-400' : 'text-zinc-400'}`} />
            <div className="min-w-0">
              <div className="flex items-center gap-1.5">
                <p className="truncate text-sm font-semibold text-zinc-900 dark:text-white">{race.name}</p>
                <span className={`rounded px-1 text-[10px] font-bold leading-4 ${priorityClasses[race.priority]}`}>
                  {race.priority}
                </span>
              </div>
              <p className="text-xs text-zinc-500 dark:text-zinc-400">
                {race.distance_miles ? `${race.distance_miles} mi · ` : ''}
                {countdown(days)}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
